module.exports = __webpack_public_path__ + "static/media/Blueberries.7bd4f540.png";